type JSONObject = { [key: string]: any };
type JSONValue = JSONObject | JSONObject[] | string | number | boolean | null | undefined;

export function removeTypename(obj: JSONValue): JSONValue {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      if (key !== '__typename') {
        acc[key] = removeTypename(obj[key]);
      }
      return acc;
    }, {} as JSONObject);
  }
  return obj;
}
